import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
    _vm._b(
      {
        tag: "component",
        attrs: { "data-qa": "lpu_loyalty_program_info" },
        scopedSlots: _vm._u(
          [
            !_setup.isMobile
              ? {
                  key: "prependBtn",
                  fn: function ({ btnProps }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                _setup.isOpened = false
                              },
                            },
                          },
                          "v-btn",
                          btnProps,
                          false
                        ),
                        [
                          _c("span", {
                            staticClass: "ui-icon-close-not-a-circle",
                          }),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column flex-grow-1 gr-4" },
                    [
                      _setup.isMobile
                        ? _c(
                            VBtn,
                            {
                              staticClass: "branding-btn branding-btn--primary",
                              attrs: {
                                "data-qa":
                                  "lpu_loyalty_program_info_btn_confirm",
                                color: "primary",
                                depressed: "",
                              },
                              on: {
                                click: function ($event) {
                                  _setup.isOpened = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_setup.t("Хорошо", _setup.options)) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-body-2 text-secondary--text text-center text-pre-line",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _setup.t(
                                "Полные условия и ограничения программы\nуточняйте в клинике",
                                _setup.options
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _setup.isOpened,
          callback: function ($$v) {
            _setup.isOpened = $$v
          },
          expression: "isOpened",
        },
      },
      "component",
      _setup.isMobile
        ? {}
        : {
            size: "lg",
            title: _setup.t("Программа лояльности клиники", _setup.options),
            divider: true,
          },
      false
    ),
    [
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            "div",
            { staticClass: "text-subtitle-1 text--text text-center mb-3" },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.t("Программа лояльности клиники", _setup.options)
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column gr-5",
          attrs: { "data-qa": "lpu_loyalty_program_info" },
        },
        [
          _c(_setup.BonusLevels, {
            attrs: { "bonus-levels": _vm.bonusLevels },
          }),
          _vm._v(" "),
          _vm.welcomeBonusAmount
            ? _c(_setup.WelcomeBonus, {
                attrs: { "welcome-bonus-amount": _vm.welcomeBonusAmount },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.BriefDetails, {
            attrs: { "max-payment-percent": _vm.maxPaymentPercent },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }